import classes from './TableCol.module.css';

const Col = (props) => {
  const className = `${classes.tc} ${props.className}`;
  return <div className={className}>{props.children}</div>;
};

export default Col;
